export const subtitles = {
    "1": {
        "startTime": 0.9380000000000001,
        "endTime": 6.33,
        "transcript": "Uskumi unisteka maliggluku ayallemegni yuilqumun nengllirluku",
        "translation": "In the winter, when I went with my late father to the wilderness when it was cold"
    },
    "2": {
        "startTime": 7.573,
        "endTime": 9.873,
        "transcript": "Qercuallinilua, wiinga-ll' nalluluku.",
        "translation": "I got frostbitten and I didn't realize it."
    },
    "3": {
        "startTime": 9.887,
        "endTime": 12.794,
        "transcript": "Tangrramia qercualliinianga-gguq ulluviigemkun.",
        "translation": "When he saw me, he said that my cheeks got frostbitten."
    },
    "4": {
        "startTime": 14.394,
        "endTime": 23.624,
        "transcript": "Qanikcarmek tamaaken tegulluni patgumallrua negingalukek ulluviigka taukuk qanikcaq-ll' urugluku.",
        "translation": "He took snow from there, pressed it against my cheeks, and the snow melted."
    },
    "5": {
        "startTime": 25.081,
        "endTime": 29.296,
        "transcript": "Tua-i qaill' pitarian tayima taq'ak.",
        "translation": "When it had been some time, he stopped."
    },
    "6": {
        "startTime": 30.452,
        "endTime": 37.667,
        "transcript": "Taukuk-llu tua-i imkucirpek'natek ulluviigka, amia au͡g'arpek'nani.",
        "translation": "And then the skin from my cheeks didn't, you know, peel off."
    },
    "7": {
        "startTime": 40.48,
        "endTime": 43.864,
        "transcript": "Tua-i tau͡gaam tuaten nallunritaqa tuana tuaten pillra.",
        "translation": "But that's what I know about how that happens."
    },
    "8": {
        "startTime": 44.465,
        "endTime": 52.165,
        "transcript": "Tayima tau͡gaam qaillun it'gamegteggun unatemeggteggun-llu pikuneng kumlamun akungqakuneng assiryarngatut.",
        "translation": "But I think it would be good to be submerged into cold water if they get frostbitten on their feet or hands."
    },
    "9": {
        "startTime": 53.111,
        "endTime": 57.168,
        "transcript": "Cangallrungaicugnarqut maaggun ulluviignegun pilleq.",
        "translation": "It probably won't be any different from getting it here on the cheeks."
    },
    "10": {
        "startTime": 57.179,
        "endTime": 66.71,
        "transcript": "Cangallrungaicugnarqut unatetgun it'gatgun-llu qercuakuni kumlamun akungqakuneng.",
        "translation": "It probably won't be any different if they get frostbitten on their hands or feet and they are submerged into cold water."
    },
    "11": {
        "startTime": 67.807,
        "endTime": 72.484,
        "transcript": "Akungqakata assirciqngatut aipaagni.",
        "translation": "They will probably be good if they are submerged."
    },
    "12": {
        "startTime": 88.03,
        "endTime": 92.084,
        "transcript": "Nenglliqerciqnilaraat tuaten piaqan.",
        "translation": "They say it will suddenly get cold when that happens."
    },
    "13": {
        "startTime": 92.105,
        "endTime": 97.028,
        "transcript": "Pinaunqumanilaraat akerta nenglliqata'rqan.",
        "translation": "They say that the sun is \"ready\" when it's going to be cold."
    },
    "14": {
        "startTime": 97.048,
        "endTime": 103.456,
        "transcript": "Nenglli'rqan-wa tua-i nenglliqata'rqan tuaten ayuqetunilallruat.",
        "translation": "When it's cold, when it's going to get cold, that's what they said it was like."
    },
    "15": {
        "startTime": 104.64,
        "endTime": 114.494,
        "transcript": "Imutun pugyaralirtun ayuqluni avatailiterluni, cali-ll' elaqvaggun cali aliimaterluni, qatellriartarluni.",
        "translation": "It would be as if it were wearing an outer parka, and wearing gloves on the outside with white parts."
    },
    "16": {
        "startTime": 115.931,
        "endTime": 124.669,
        "transcript": "Tua-i-gguq-qaa nengllircuuciqluni. Tuaten nenglliqata'rqan-llu, nengllirturaqerkaugaqan-wa tua-i pitullilria.",
        "translation": "They said that it will get cold. That probably happens when it's going to be cold for a while."
    },
    "17": {
        "startTime": 124.957,
        "endTime": 125.873,
        "transcript": "Ak'anun?",
        "translation": "For a long time?"
    },
    "18": {
        "startTime": 127.667,
        "endTime": 133.205,
        "transcript": "Tuaten ayuqetungatuq. Tuatnatuniluku tua-i qanrutketullruat.",
        "translation": "I think it's like that. They said that it would be like that."
    },
    "19": {
        "startTime": 133.653,
        "endTime": 137.276,
        "transcript": "Ingrit-llu-ggem qaillun ellassuutekluki qanrutek'larait.",
        "translation": "Don't they also say that they would use the mountains for weather forecasts?"
    },
    "20": {
        "startTime": 137.842,
        "endTime": 142.842,
        "transcript": "Ingrit cali tua-i qaillun murilketalriit tamaa-i ilaita",
        "translation": "The mountains also, since some of them were observant"
    },
    "21": {
        "startTime": 142.883,
        "endTime": 154.363,
        "transcript": "Wiinga murilketailama, ingrit agkut caqtaaraqata-wa tua-i inimaaqluki-llu piaqata",
        "translation": "Because I'm not observant, when those mountains across there do something, when there are mirages on the horizon"
    },
    "22": {
        "startTime": 155.203,
        "endTime": 158.383,
        "transcript": "Cassuutnguniluki caqatarniluki tua-i pilaraat.",
        "translation": "They say that it's a sign of some kind of weather."
    },
    "23": {
        "startTime": 158.941,
        "endTime": 170.133,
        "transcript": "Tau͡gaam qertuaqameng agkut ingrit cingikeggluni-ll' ilait qulmun nenglaitessuutnguyugnarquq tamana.",
        "translation": "But when the mountains across are high, and some of them have sharp summits, I think that's a sign of warm weather."
    },
    "24": {
        "startTime": 206.139,
        "endTime": 218.277,
        "transcript": "Wiinga ikna ingriq ikani, wii ikna ingriq ikani cingikellria tau͡gken cingiani cingikeggluni tangl'arqa, maaken-ll' alaitetuluni.",
        "translation": "I see the mountain across there with the sharp summit, and it's visible from here."
    },
    "25": {
        "startTime": 218.304,
        "endTime": 226.292,
        "transcript": "Avaken-llu pikani Qanirtuum Qagatiini uitalallemni alaunani tuaken cingikeggluni.",
        "translation": "And when I used to live up in Qanirtuum Qagatii over there, it would be visible with a sharp summit."
    },
    "26": {
        "startTime": 227.389,
        "endTime": 232.239,
        "transcript": "Tauna tua-i nenglaiteqata'rqan nenglaitessuutekaqa.",
        "translation": "When it's going to be warm, I use it as a sign."
    },
    "27": {
        "startTime": 232.581,
        "endTime": 241.319,
        "transcript": "Qulmun cingikeggiluni waten mayurluni caqtaarluni piaqan, tua-i nenglairutqata'arqan tuatnangatelartuq.",
        "translation": "When the summit seems to get sharper and rise acting strangely, it seems to do that when it's going to get warm."
    },
    "28": {
        "startTime": 243.968,
        "endTime": 255.055,
        "transcript": "Murilketalriit tamaa-i nallunrit'lallruat tamaani yaaqvani ciuqliit au͡gkut yullret.",
        "translation": "The observant ones back then would know, the people of old back then."
    },
    "29": {
        "startTime": 256.478,
        "endTime": 262.228,
        "transcript": "Catgun-wa tua-i pingnatugatullermeggni ellameturpallurluteng pitullruameng",
        "translation": "When they used to survive with various tools, because they were always outside"
    },
    "30": {
        "startTime": 262.763,
        "endTime": 269.663,
        "transcript": "Unugmi-llu cat nallunailkurluki agyat-llu pitustait tamakut nallunritaat.",
        "translation": "And those who use them know to use the stars at night as signs of incoming weather."
    },
    "31": {
        "startTime": 270.722,
        "endTime": 274.522,
        "transcript": "Maa-i tua-i tuatnalriartangqessuirutlilria tayima.",
        "translation": "There is probably no one who does that now."
    },
    "32": {
        "startTime": 275.445,
        "endTime": 281.791,
        "transcript": "Naamelliin. Nallunarqellriit ayagyuat ilait qanrutellrit tuatnatuyugngallilriit tayima.",
        "translation": "I'm not sure. Some young people who were told can probably do that."
    },
    "33": {
        "startTime": 307.641,
        "endTime": 312.172,
        "transcript": "Tua-i ilumun ellaliurtetun ayuqellrulliniut tamakut murilketalriit.",
        "translation": "Those observant ones were indeed like weather forecasters."
    },
    "34": {
        "startTime": 312.999,
        "endTime": 318.893,
        "transcript": "Tua-i nalluyuunaku tayima ellaita cuqyut'megteggun, cuqtellermegteggun",
        "translation": "They knew through their signs, how they gauged the signs"
    },
    "35": {
        "startTime": 319.557,
        "endTime": 322.657,
        "transcript": "Agyatgun wall'u ellam qaillun waten ayuqellrakun.",
        "translation": "Through the stars or how the weather was like."
    },
    "36": {
        "startTime": 323.51,
        "endTime": 326.802,
        "transcript": "Tamaa-i nalluyuunaku tamana ellam qaillun ayuqellerkaa.",
        "translation": "They knew what the weather was going to be like."
    },
    "37": {
        "startTime": 328.059,
        "endTime": 333.536,
        "transcript": "Tua-i ilaita tamaa-i ukveqestaita tua-i tamakut maligtaqutullruit.",
        "translation": "Some of those who believed in them would follow them."
    },
    "38": {
        "startTime": 334.108,
        "endTime": 341.316,
        "transcript": "Tua-i-ll' cali imkut ingrini agaani qangaanaat cali au͡g'um iliita qanemcitellruanga",
        "translation": "And then the squirrels in the mountains across there, one of them also told me a story"
    },
    "39": {
        "startTime": 342.286,
        "endTime": 349.84,
        "transcript": "Waten-gguq ellarayakata'arqan akaarnun ella assiiteqata'rqan iqrit ukut imartutuut.",
        "translation": "He said that when the weather is going to be bad for a long while, their cheeks have a lot in them."
    },
    "40": {
        "startTime": 350.736,
        "endTime": 361.086,
        "transcript": "Atsanek, piciautun nertuk'meggnek imirluki, tua-i igteḿun tamaa-i ellarayiim taktaciatun taukunek iqmimeggnek imaitnek nerluteng.",
        "translation": "They fill them with berries or other things they eat, go to their dens, then eat from the stores in their cheeks for as long as the weather is bad."
    },
    "41": {
        "startTime": 362.111,
        "endTime": 364.651,
        "transcript": "Neqerluteng tuani igteḿi uitaurluteng.",
        "translation": "They stay there in the den with food."
    },
    "42": {
        "startTime": 380.735,
        "endTime": 382.105,
        "transcript": "Cakuciullruat yaaruit?",
        "translation": "What were storyknives made of?"
    },
    "43": {
        "startTime": 382.902,
        "endTime": 388.36,
        "transcript": "Yaaruitengqelallruunga wii tulurrarmek, tulurmek, ivory.",
        "translation": "I had a storyknive made out of ivory, tuluq, ivory."
    },
    "44": {
        "startTime": 388.604,
        "endTime": 390.62,
        "transcript": "Kia-ll' tayim' piliaqellruagu.",
        "translation": "And I'm not sure who made it."
    },
    "45": {
        "startTime": 391.231,
        "endTime": 393.873,
        "transcript": "Tua-i yaaruilrianga taqsuunii.",
        "translation": "I would never stop telling storyknife stories."
    },
    "46": {
        "startTime": 395.084,
        "endTime": 404.309,
        "transcript": "Friend-angqelaamta-llu friend-aput-llu elitnaunritaqamta tua-i yaaruiq tau͡gaam.",
        "translation": "And since we had friends, we would only tell storyknife stories with our friends when we weren't in school."
    },
    "47": {
        "startTime": 404.767,
        "endTime": 414.24,
        "transcript": "Yaaruinaurtukut yaaruiraput-llu wangkuk friend-aqa-llu aterluteng, taukut nunat.",
        "translation": "We would tell storyknife stories, and the villages from my friend's and my storyknife stories would have names."
    },
    "48": {
        "startTime": 414.989,
        "endTime": 417.448,
        "transcript": "Aterluteng pingkuunguarluteng.",
        "translation": "They had names as we pretended they were inland."
    },
    "49": {
        "startTime": 418.085,
        "endTime": 420.168,
        "transcript": "Family-unguartelluki.",
        "translation": "We had them pretend to be a family."
    },
    "50": {
        "startTime": 420.405,
        "endTime": 428.495,
        "transcript": "Ukut-wa-w' aiparnatuka tua-i acirnaurai pingkuunguartelluki.",
        "translation": "My playmate would name these the inlanders."
    },
    "51": {
        "startTime": 428.815,
        "endTime": 436.656,
        "transcript": "Ukut-wa-gguq Nunapigngiaraankut, ukut-wa Ceńaqviuksuunkut yaaqlikacagaugurarcetaqluki.",
        "translation": "These would be the Tundra People, and she would have the Coastal People always be over here."
    },
    "52": {
        "startTime": 436.793,
        "endTime": 442.577,
        "transcript": "Nunapigngiaraankut tua-i acirluki tamakut nunat yuut.",
        "translation": "She would name that village and the people the Tundra People."
    },
    "53": {
        "startTime": 442.933,
        "endTime": 447.116,
        "transcript": "Familiy-linguaraqluta-ll' eneliluki tua-i.",
        "translation": "We would make up families and give them houses."
    },
    "54": {
        "startTime": 449.447,
        "endTime": 451.913,
        "transcript": "Pingqerruangaqluteng? Atengqerruangaqluteng?",
        "translation": "Would they have things? Would they have names?"
    },
    "55": {
        "startTime": 452.417,
        "endTime": 460.867,
        "transcript": "Cangqerruartelluki tua-i wangkucicetun, wangkuta tangvallemcetun. Pilallratnun pinguarcequ'urluki.",
        "translation": "We would pretend that they would have things like what we've seen. They would have normal things."
    },
    "56": {
        "startTime": 462.517,
        "endTime": 468.867,
        "transcript": "Yaaruinritaqamta-llu atakumi airrarluta imkunek string.",
        "translation": "And when we didn't tell storyknife stories, we played string games."
    },
    "57": {
        "startTime": 472.383,
        "endTime": 483.858,
        "transcript": "Tau͡gaam inerquraqluta ak'anun airraasqevkenata egacuayagmun iterciqniluta camun airralriamun.",
        "translation": "But they would admonish us against playing string games for too long saying that an elf would enter to whomever is playing string games."
    },
    "58": {
        "startTime": 484.2,
        "endTime": 488.893,
        "transcript": "Tua-i ak'anun pivkenata airrarraarluta taq'aqluta.",
        "translation": "We wouldn't do it for long, but stop after playing some string games."
    },
    "59": {
        "startTime": 493.869,
        "endTime": 494.84,
        "transcript": "I don't know.",
        "translation": "I don't know."
    },
    "60": {
        "startTime": 495.773,
        "endTime": 501.273,
        "transcript": "Kiagmi-llu, kiagmi-llu inuguaraqluta.",
        "translation": "And in the summer, we would play with small dolls."
    },
    "61": {
        "startTime": 502.238,
        "endTime": 506.588,
        "transcript": "Inuguangqerrluta almost every girl.",
        "translation": "We had small dolls, almost every girl."
    },
    "62": {
        "startTime": 508.87,
        "endTime": 516.363,
        "transcript": "Inuguangqerraqluteng amllernek inuguanek. Family-cuaraugaqluteng ukut.",
        "translation": "They would have a lot of small dolls. These would make up a small family."
    },
    "63": {
        "startTime": 517.915,
        "endTime": 523.715,
        "transcript": "Makut-wa cali irniaruat. Tamakunek naanguangqelallruukut.",
        "translation": "And then these other dolls. Those were the toys we had."
    },
    "64": {
        "startTime": 540.138,
        "endTime": 543.35,
        "transcript": "Ataka tua-i ayakataraqan",
        "translation": "When my father was going to travel"
    },
    "65": {
        "startTime": 544.229,
        "endTime": 557.429,
        "transcript": "Aanama tua-i upnauraa neqkainek, saayunek, saarralamek. Kenircuutaicuunateng.",
        "translation": "My mother would prepare food for him, tea, sugar. They always had things to cook with."
    },
    "66": {
        "startTime": 558.516,
        "endTime": 566.682,
        "transcript": "Tamaa-i tau͡gaam ella assiraqan ellakun kenituluteng tamakut angutet.",
        "translation": "But when the weather was good, those men would cook outdoors."
    },
    "67": {
        "startTime": 570.774,
        "endTime": 573.621,
        "transcript": "Ellmeggnek-qaa neqnek piaqluteng, pissuraqluteng?",
        "translation": "Would they hunt for their own food?"
    },
    "68": {
        "startTime": 574.807,
        "endTime": 575.587,
        "transcript": "Ii-i.",
        "translation": "Yes."
    },
    "69": {
        "startTime": 578.053,
        "endTime": 584.293,
        "transcript": "Maaten-llu pinauranka kuvyinaurtut string-anek pililuteng.",
        "translation": "And then I would find that they would make drift nets out of string."
    },
    "70": {
        "startTime": 585.34,
        "endTime": 595.81,
        "transcript": "Ataka-llu neqsurcuuciaqluni muragnek canaluni. Taluyaliluni can'giircuutnek.",
        "translation": "My father would also carve wood for fishing tools. He would make blackfish traps."
    },
    "71": {
        "startTime": 596.669,
        "endTime": 604.781,
        "transcript": "Pissurcuuciaqluteng-llu taluyanek, kapkaananek ilaluki angutet tangvalallrenka.",
        "translation": "The men I've seen would also make conical traps for land animals, adding in steel traps."
    },
    "72": {
        "startTime": 629.022,
        "endTime": 635.897,
        "transcript": "Invite-alteng nunat allat tekicata angutet qasgivkarluki.",
        "translation": "When the other villages they invited arrived, they would take the men to the community house."
    },
    "73": {
        "startTime": 636.813,
        "endTime": 641.719,
        "transcript": "Qasgim-llu ingelran iliit un'gavet elliluku qulvanun.",
        "translation": "And they would place one of the benches and put it high up near the exit."
    },
    "74": {
        "startTime": 642.005,
        "endTime": 647.255,
        "transcript": "Taukut-llu angutet tamaavet aqumlluki payugarrluki.",
        "translation": "And they would seat the men there and bring them food."
    },
    "75": {
        "startTime": 648.557,
        "endTime": 650.595,
        "transcript": "Tua-i-gguq payugarrluki.",
        "translation": "They would call it bringing them food."
    },
    "76": {
        "startTime": 651.903,
        "endTime": 660.29,
        "transcript": "Neqkaitnek payuggluki neqnek keniranek wall'u, wall'u dry fish-anek yuurkaitnek-llu.",
        "translation": "They would bring them cooked food to eat, or dried fish along with tea."
    },
    "77": {
        "startTime": 660.981,
        "endTime": 665.831,
        "transcript": "Tua-i-llu nernerrlugcetaariluteng nerngarcata.",
        "translation": "And then they would try to disrupt their meals when they started eating."
    },
    "78": {
        "startTime": 666.284,
        "endTime": 674.278,
        "transcript": "Tamakut allanret angutet nerngarcata yuarutmek emengluteng nunat.",
        "translation": "When those visiting men started eating, the village would start drumming a song."
    },
    "79": {
        "startTime": 676.053,
        "endTime": 678.828,
        "transcript": "Tua-i-gguq nernerrlugcetaarluki.",
        "translation": "They called it disrupting their meals."
    },
    "80": {
        "startTime": 679.025,
        "endTime": 685.912,
        "transcript": "Apa'urluunka aqumlua tangvakenka, last one, that was the last one.",
        "translation": "I sat and watched my grandfathers and great-uncles, the last one, that was the last one."
    },
    "81": {
        "startTime": 686.872,
        "endTime": 693.647,
        "transcript": "Murilkelluki tangvallruaqa atama uncle-aari Paingarmiut.",
        "translation": "I observed and watched my father's uncle from Paingaq."
    },
    "82": {
        "startTime": 693.804,
        "endTime": 700.748,
        "transcript": "Waten nunacuarmiut atulriit atuulluki nernerrlugcetaarluki",
        "translation": "The villagers would sing for them like this to disrupt their meals"
    },
    "83": {
        "startTime": 701.024,
        "endTime": 705.375,
        "transcript": "So they can choke, or can't swallow, or something like that.",
        "translation": "So they can choke, or can't swallow, or something like that."
    },
    "84": {
        "startTime": 705.62,
        "endTime": 707.176,
        "transcript": "Atuuskait waten:",
        "translation": "They sang to them like this:"
    },
    "85": {
        "startTime": 707.839,
        "endTime": 717.329,
        "transcript": "\"Talluryuyuilngurnun nalirrugcetaarilii",
        "translation": "\"Let me make those who do not get embarrassed become undecided"
    },
    "86": {
        "startTime": 717.692,
        "endTime": 724.728,
        "transcript": "\"Nalirriarngualriit avukuulluki-qaa?",
        "translation": "\"Do I lump in everyone who's undecided?"
    },
    "87": {
        "startTime": 725.318,
        "endTime": 744.058,
        "transcript": "\"Ata-ggem ukuni Akulurarmiuni aturyuktaalarmiut cakegtaunriluciq calliggluku maavet.",
        "translation": "\"Don't these people from Akuluraq also want to sing repeatedly, scattering nothing of value here?"
    },
    "88": {
        "startTime": 744.1,
        "endTime": 748.617,
        "transcript": "\"Aturyuktaalarmiut.\"",
        "translation": "\"They also want to repeatedly sing.\""
    },
    "89": {
        "startTime": 749.015,
        "endTime": 760.232,
        "transcript": "Imkuk-ll' apallirtulriit angutek matarmek, uyamignek makurlutek, nasqurruterlutek, qerrulliglutek tau͡gaam waten elliurlutek.",
        "translation": "But the two naked men who sang the verses, with necklaces here, headdresses, but with pants, would do this."
    },
    "90": {
        "startTime": 761.303,
        "endTime": 768.637,
        "transcript": "Tua-i-ll' enipagluki, \"Unagkurluut-llam pivakengraata.\"",
        "translation": "And then they would specifically point them out, \"Even if those out there think they're important.\""
    },
    "91": {
        "startTime": 769.255,
        "endTime": 771.813,
        "transcript": "Ala-i, alingnaqluteng.",
        "translation": "Oh my, they were frightening."
    },
    "92": {
        "startTime": 772.973,
        "endTime": 776.448,
        "transcript": "Tua-i-gguq nernerrlugcetaarluki.",
        "translation": "They called that disrupting their meals."
    },
    "93": {
        "startTime": 794.862,
        "endTime": 798.662,
        "transcript": "Wiinga uikamnek wangnek choose-allrunritua.",
        "translation": "I didn't choose my own husband."
    },
    "94": {
        "startTime": 800.199,
        "endTime": 802.585,
        "transcript": "Aulukesteḿa choose-autellruanga.",
        "translation": "My caretaker chose for me."
    },
    "95": {
        "startTime": 802.588,
        "endTime": 811.2,
        "transcript": "Avani-wa qigcikuutellruameng yuut takaqulluteng camun kenekngiinalqa nallukeka.",
        "translation": "Because the people were respectful and deferential to each other, I don't know to whom I was starting to love."
    },
    "96": {
        "startTime": 812.257,
        "endTime": 818.864,
        "transcript": "Tau͡gaam maligtaqu'urluki aipaput pisqetullrukait assirluta aipauyukumta.",
        "translation": "But they told us to obey our spouses if we wanted to be good spouses."
    },
    "97": {
        "startTime": 819.529,
        "endTime": 824.679,
        "transcript": "Wiinga uika cumikellemni wall' uikellemni",
        "translation": "When I took care of my husband, or when I was married to him"
    },
    "98": {
        "startTime": 825.306,
        "endTime": 834.106,
        "transcript": "Assikaqa takaqulluta atunem pillerput, caunrilkutevkenata.",
        "translation": "I like mutually respecting each other, not treating each other badly."
    },
    "99": {
        "startTime": 835.733,
        "endTime": 844.869,
        "transcript": "Uima-llu caliyaurpailegmi pissulallrani ellma pitai aulukaqluki assingnaqluki",
        "translation": "And before my husband started working, I would try to take good care of what little he caught"
    },
    "100": {
        "startTime": 845.813,
        "endTime": 849.005,
        "transcript": "Pitat-wa tua-i animal-aat.",
        "translation": "Well, the animals that he caught."
    },
    "101": {
        "startTime": 869.436,
        "endTime": 883.636,
        "transcript": "Maa-i tau͡gken pegutelallrat elluatuunrirluteng ayagyuat ellaita cucukellermeggnek uingelaameng",
        "translation": "Divorcing now, however, the young people are getting worse because they marry husbands they chose themselves"
    },
    "102": {
        "startTime": 883.769,
        "endTime": 888.581,
        "transcript": "Parent-aarita cucukutevkenaki ellmeggnek nulirqut'laameng.",
        "translation": "Because their parents don't choose for them, instead marrying whomever they want."
    },
    "103": {
        "startTime": 888.78,
        "endTime": 899.818,
        "transcript": "Tamaa-i-llu avvutelallrat ellaita piyullermeggnek piluteng parent-aateng ataneqevkenaki.",
        "translation": "And they divorce because they choose their own without listening to their parents."
    },
    "104": {
        "startTime": 900.226,
        "endTime": 901.663,
        "transcript": "Man'a-mi taangaq?",
        "translation": "What about alcohol?"
    },
    "105": {
        "startTime": 902.031,
        "endTime": 908.613,
        "transcript": "Taangaq-llu man'a murilkellemni ukaqvani taangaq amlleriuq.",
        "translation": "And this alcohol, in my observation, there is more alcohol recently."
    },
    "106": {
        "startTime": 908.893,
        "endTime": 916.378,
        "transcript": "Nulirqellriik, nulirqellriit uingit taangatukuni nulirra-llu taangiqsuunani",
        "translation": "And for married couples, if the husband drinks alcohol and the wife doesn't"
    },
    "107": {
        "startTime": 918.019,
        "endTime": 922.519,
        "transcript": "Nulirran unaksuumaa assirivkarluku uini.",
        "translation": "The wife will want the husband to get better."
    },
    "108": {
        "startTime": 924.293,
        "endTime": 929.216,
        "transcript": "Uini-wa taqevkangnaqluku taangiq'lallranek.",
        "translation": "She will want her husband to stop drinking alcohol."
    },
    "109": {
        "startTime": 930.307,
        "endTime": 936.546,
        "transcript": "Yuk, arnak yuk Agayutmek nalluvkenani piicatukuni",
        "translation": "If a woman knows God and prays"
    },
    "110": {
        "startTime": 937.175,
        "endTime": 941.406,
        "transcript": "Agayutem niiciiqaa piyullranek, uinga-llu tauna taangayuirulluni.",
        "translation": "God will hear what she asks for, and her husband will stop drinking alcohol."
    },
    "111": {
        "startTime": 942.014,
        "endTime": 948.552,
        "transcript": "Wall'u-wa nulirqellriit uinga taangatukuni nulirra-llu taangayuiqaarluni",
        "translation": "Or with married couples, if the husband drinks and the wife doesn't"
    },
    "112": {
        "startTime": 948.735,
        "endTime": 958.373,
        "transcript": "Uini aipingkuniu, tua-i-llu taukuk navgullutek, navgullutek nakukucuglutek, avvullutek-llu tua-i.",
        "translation": "If she joins her husband, they will destroy each other, destroy each other and fight each other, then divorce."
    },
    "113": {
        "startTime": 981.92,
        "endTime": 988.812,
        "transcript": "Amllernek tanglartua assilrianek nulirqellrianek, kenkitarluteng-llu irniameggnek.",
        "translation": "I see many married couples who also love their children."
    },
    "114": {
        "startTime": 990.587,
        "endTime": 997.444,
        "transcript": "Tamatum tau͡gaam ataucim mat'um maa-i nalliini arcaqerluki navgungai nulirqellriit.",
        "translation": "That one thing is what is destroying married couples these days."
    },
    "115": {
        "startTime": 998.225,
        "endTime": 1009.067,
        "transcript": "Taangiqaqameng iciw' yuut tangvalaqeput tua-i piciatun pilallrit. Takaryugpek'nateng-llu, uumek-llu arnamek qaillun piaqluteng kenkuriluteng.",
        "translation": "You know we see people do various things when they're drunk. They are not ashamed, and make love to this random woman."
    },
    "116": {
        "startTime": 1009.218,
        "endTime": 1011.635,
        "transcript": "Tua-i-wa takaircameng.",
        "translation": "It's because they're not ashamed anymore."
    },
    "117": {
        "startTime": 1012.981,
        "endTime": 1026.181,
        "transcript": "Tamakut pegcikuneng, ircaqumegteggun ukverluteng, ircaqumegteggun pegcikuneng assiriyugngaut.",
        "translation": "If they give it up, believing in their hearts, if they give it up in their hearts, they can get better."
    },
    "118": {
        "startTime": 1027.352,
        "endTime": 1032.152,
        "transcript": "Assinrurcugngaut-llu wangkutni taangiqeksailengramta yuullerni.",
        "translation": "And they can become better than we who have never drank alcohol in our lives."
    },
    "119": {
        "startTime": 1047.135,
        "endTime": 1050.942,
        "transcript": "Assirluni yuk yuuyukuni",
        "translation": "If a person wants to live well"
    },
    "120": {
        "startTime": 1052.113,
        "endTime": 1058.419,
        "transcript": "Angayuqaagminek niisngaluni, niisngallermikun assirluni yuuyugngauq.",
        "translation": "He can live well by obeying his parents."
    },
    "121": {
        "startTime": 1059.772,
        "endTime": 1064.905,
        "transcript": "Angayuqaulriani irniaput waten alerqurngaitaput:",
        "translation": "We who are parents will not instruct our children like this:"
    },
    "122": {
        "startTime": 1065.271,
        "endTime": 1069.536,
        "transcript": "\"Ankuvet assiinak pikina.\" Nuu, tamakunek pingaitaput.",
        "translation": "\"When you go out, misbehave.\" No, we will not tell them that."
    },
    "123": {
        "startTime": 1069.93,
        "endTime": 1075.03,
        "transcript": "Irniaput assirluki tamalkumta pisqumalaraput.",
        "translation": "We all want our children to be good."
    },
    "124": {
        "startTime": 1075.46,
        "endTime": 1083.82,
        "transcript": "Cali-llu makut maa-i ayagyuat nulirqutellriit mat'um nalliini",
        "translation": "Also, these young people who are married today"
    },
    "125": {
        "startTime": 1085.866,
        "endTime": 1094.74,
        "transcript": "Uiteng, wall'u-w' angutem nuliani, wall' arnam uini takaqenritsiyaallrata navgutuit.",
        "translation": "When they don't respect their husbands, or the men their wives, or the women their husbands, it destroys them."
    },
    "126": {
        "startTime": 1095.604,
        "endTime": 1100.038,
        "transcript": "Caunrilkelluki ellait angenrurrluteng.",
        "translation": "They disparage each other and consider themselves as more important."
    },
    "127": {
        "startTime": 1100.129,
        "endTime": 1104.422,
        "transcript": "Waten wiinga niitelallruunga uingellemni:",
        "translation": "I would hear this when I took a husband:"
    },
    "128": {
        "startTime": 1104.788,
        "endTime": 1114.548,
        "transcript": "Uiput-gguq, uiput-gguq ikiungraata wall' tussitengraata, qaill' ayuqengraata takaqerkaugaput caunrilkevkenaki.",
        "translation": "They said that even if our husbands are ugly or crippled, no matter what they're like, we must respect them and not treat them badly."
    },
    "129": {
        "startTime": 1114.794,
        "endTime": 1126.783,
        "transcript": "Mat'um nalliini nulirqutellriit elluatuunrillrat, ellmeggnek-llu uikameggnek cucuklirluteng uingluteng ayuquciit yuvrirpek'naki",
        "translation": "And how married couples are getting worse these days, they also choose their own husbands without examining what they're like"
    },
    "130": {
        "startTime": 1126.887,
        "endTime": 1133.78,
        "transcript": "Kegginaqecillran, kegginaq tangniqellran pivkarluku, ayuquciit tau͡gken assiitelliniluteng.",
        "translation": "It because they have good faces, but their dispositions are bad."
    },
    "131": {
        "startTime": 1134.022,
        "endTime": 1138.443,
        "transcript": "Tamakut elluarrluki nulirqucecuitait.",
        "translation": "That is what keeps them from having good marraiges."
    },
    "132": {
        "startTime": 1139.122,
        "endTime": 1142.815,
        "transcript": "Avani alerqutullrulliniit",
        "translation": "Long ago, they used to instruct people"
    },
    "133": {
        "startTime": 1143.281,
        "endTime": 1151.296,
        "transcript": "Yuk-gguq kegginarrliqengraan, kegginaa ikiungraan uikesqelluku, elluarrluku taumun aulukciqniluku.",
        "translation": "They said that even if a person was ugly, to marry him even if he had an ugly face, saying that he will take good care of her."
    },
    "134": {
        "startTime": 1151.3,
        "endTime": 1152.643,
        "transcript": "Cunaw' piciuluni.",
        "translation": "It turned out to be true."
    },
    "135": {
        "startTime": 1153.167,
        "endTime": 1163.567,
        "transcript": "Maa-i nulirqellriit uimeggnek caunrilkissiyaallrata wall' uumek tan'gaurlurmek caunrilkillrata elluatuunrircetait.",
        "translation": "These days in married couples, they are becoming bad because they treat their husbands or these boys very badly."
    },
    "136": {
        "startTime": 1163.746,
        "endTime": 1168.826,
        "transcript": "Makut qanruyutet niicuilamegteki nalluut.",
        "translation": "They don't know because they don't hear this traditional wisdom."
    },
    "137": {
        "startTime": 1192.354,
        "endTime": 1203.804,
        "transcript": "Ilateng mulngakluki, ilaput mulngakluki pilaasqelluki qanemteńek. Cali-llu qanengqerrnitkevkenata yuusqelluta.",
        "translation": "They told us to be careful of our mouths towards those around us. They also told us not to live by saying harsh words just because we have mouths."
    },
    "138": {
        "startTime": 1205.009,
        "endTime": 1215.032,
        "transcript": "Yurrluuvakalriit-gguq kiaresngiataallerkameggnun tekitaatuut, qanengqerrvakalriit-llu.",
        "translation": "They said that those who are bad people come to shame many times along with those who say too many harsh words."
    },
    "139": {
        "startTime": 1215.73,
        "endTime": 1224.646,
        "transcript": "Kia allayugtun-llu-gguq tangaatuut, tua-i-ll' ellait pisqucimegcetun.",
        "translation": "They say that they are seen in different ways, and then as they want to be."
    },
    "140": {
        "startTime": 1224.962,
        "endTime": 1237.112,
        "transcript": "Tuamtell' cali picilirtuumangramta neplingnaqevkenata uitalaasqaqluta wangkuta piksailkumta.",
        "translation": "And then they would tell us to try to stay quiet even if we are blamed if we didn't do it."
    },
    "141": {
        "startTime": 1238.14,
        "endTime": 1240.653,
        "transcript": "Inerquutnguluni cali.",
        "translation": "That was also an admonishment."
    },
    "142": {
        "startTime": 1242.988,
        "endTime": 1252.688,
        "transcript": "Tuamtell' cali anagulluta yugnun yugnaassiyaasqevkenata inerquumatullruluta.",
        "translation": "And then we would be admonished against going after people too much."
    },
    "143": {
        "startTime": 1253.067,
        "endTime": 1262.954,
        "transcript": "Atam-gguq cali umyuamta pekyutkaanun tekitelarniartukut wall'u assiilngurnek niiqluta.",
        "translation": "They said that we would come to times of mental hardship or keep hearing of bad things."
    },
    "144": {
        "startTime": 1265.316,
        "endTime": 1270.991,
        "transcript": "Waten qanrucimalallruukut.",
        "translation": "This is what we were told."
    },
    "145": {
        "startTime": 1271.599,
        "endTime": 1291.619,
        "transcript": "Cali-llu kelguk'ngelaasqevkenata ilaput, ilaput tua-i-wa im'uluki, pingraitki qanqeryuutevkenaki cali nepngurutngulaan tamana.",
        "translation": "Also, they told us not to invite our families into saying things about them because that also brings discord."
    },
    "146": {
        "startTime": 1317.619,
        "endTime": 1327.231,
        "transcript": "Qanrucimalallruunga, kitak-gguq mikelnguunrirtua, arnaurtua.",
        "translation": "I would be told that I am no longer a child, that I've become a woman."
    },
    "147": {
        "startTime": 1327.723,
        "endTime": 1335.935,
        "transcript": "Tau͡gaam-gguq cat tamalkuita erurirrlainarlua tegulalaqilaki.",
        "translation": "But they said that I should always take things to wash them."
    },
    "148": {
        "startTime": 1336.513,
        "endTime": 1346.05,
        "transcript": "Tuamtell' cali angutet akluit ayuqluki aklut amlliralaasqevkenaki, neqet-llu.",
        "translation": "And then they told me never to step over men's clothes no matter what they were, nor fish."
    },
    "149": {
        "startTime": 1350.592,
        "endTime": 1353.479,
        "transcript": "Amlliralaasqevkenaki neqet-llu.",
        "translation": "They told me not to step over even food."
    },
    "150": {
        "startTime": 1353.568,
        "endTime": 1358.943,
        "transcript": "Caarrlugmek-gguq imkularaput, kanvelaraput.",
        "translation": "They say that we, you know, scatter impurity on them."
    },
    "151": {
        "startTime": 1359.37,
        "endTime": 1369.42,
        "transcript": "Tuamtell' nuyanka angimalaasqevkenak. Caarrlugmek-gguq kuvuartelaraput kanevluki.",
        "translation": "And then they told me not to keep my hair untied. They said that we drop and scatter impurity."
    },
    "152": {
        "startTime": 1396.677,
        "endTime": 1405.017,
        "transcript": "Ukuk-gga angutngurtellriik wanigg' ualirnermi uani iqukacagarmi uitaluni",
        "translation": "And these two old men, one was at near the door at the very end"
    },
    "153": {
        "startTime": 1405.858,
        "endTime": 1414.688,
        "transcript": "Cali ikna iqukacagarmi cali uitaluni. Taukuk qaneryarameng egelracilriik.",
        "translation": "There was also one across there at the very end. They were bringing forth traditional wisdom."
    },
    "154": {
        "startTime": 1415.655,
        "endTime": 1424.905,
        "transcript": "Civunerkiutulik taukuk tamarmek una wani qanrraarcelluku ukalirnermelnguq",
        "translation": "Both of those who were talking about life ahead, after having the one toward here talk"
    },
    "155": {
        "startTime": 1425.56,
        "endTime": 1431.9,
        "transcript": "Ayuqucirkaat una qanrutkarkartek paivqaarluku",
        "translation": "After bringing up the things they had to say about how they should be"
    },
    "156": {
        "startTime": 1433.174,
        "endTime": 1437.924,
        "transcript": "Waten cuullerkaat ayuqellerkaat qanrutekluku.",
        "translation": "They talked about how they should live and be like this."
    },
    "157": {
        "startTime": 1440.141,
        "endTime": 1445.801,
        "transcript": "Tua-i-ll' taqngan ik'um cali kituggluku akiqlian.",
        "translation": "And then when he was finished, the one on the other side would correct him."
    },
    "158": {
        "startTime": 1446.61,
        "endTime": 1449.03,
        "transcript": "Waten cuusqelluku cuk.",
        "translation": "He said a person should live like this."
    },
    "159": {
        "startTime": 1449.919,
        "endTime": 1459.729,
        "transcript": "Qasgimiungung'e'rmeng, ataunge'rmeng, irnialing'e'rmeng taukuk qaneryarakek canrilkenritait.",
        "translation": "Even if they lived in the community house, were father, or had a lot of children, they didn't disregard their traditional wisdom."
    },
    "160": {
        "startTime": 1460.912,
        "endTime": 1464.822,
        "transcript": "Nep'ariataquq qasgi taukuk qanraqagneng.",
        "translation": "The community house would be quiet when they spoke."
    },
    "161": {
        "startTime": 1491.859,
        "endTime": 1502.217,
        "transcript": "Tuamtell' call' irniangama cali qanrucimalallruunga qanrutaqluku tauna mikelnguq pisqelluku.",
        "translation": "And then when I had a child, I was told to teach that child."
    },
    "162": {
        "startTime": 1503.161,
        "endTime": 1506.121,
        "transcript": "Mikelnguut-gguq nalluyagutaitut.",
        "translation": "They said that chidlren do not forget."
    },
    "163": {
        "startTime": 1506.535,
        "endTime": 1521.31,
        "transcript": "Tuamtellu inerquraqlua canek apqaulaasqevkenaku, wall' ilainun qaillun ayuqucianek apqaulaasqevkenaku.",
        "translation": "And then they would admonish me against asking him questions, or asking him about what his peers are like."
    },
    "164": {
        "startTime": 1522.964,
        "endTime": 1531.651,
        "transcript": "Cali-llu wani eyuqsaunaki. Nauwa ilait eyurnayugalalriit?",
        "translation": "Also, do not defend them. You know how some are defensive?"
    },
    "165": {
        "startTime": 1531.706,
        "endTime": 1538.968,
        "transcript": "Tua-i-ll' eyurnakeksaunaku-gguq inerquraqluku tau͡gaam.",
        "translation": "And then they told me not to defend him but to admonish him."
    },
    "166": {
        "startTime": 1538.984,
        "endTime": 1549.871,
        "transcript": "Tua-i-gguq-wa eyulaqumku-gguq iqluqullerkaanun qannguatullerkaanun eguaqurciqaqa.",
        "translation": "They said that if I defend him, I will encourage him to lie and say false things."
    },
    "167": {
        "startTime": 1550.118,
        "endTime": 1562.196,
        "transcript": "Tuamtell' cali wani anagulluki yagiralaasqevkenaki inerqulallruatnga.",
        "translation": "And then they would also admonish me against physically punishing them too much."
    },
    "168": {
        "startTime": 1562.637,
        "endTime": 1565.375,
        "transcript": "Atam-gguq asvaircarniarqa.",
        "translation": "They said that I would make him unstable."
    },
    "169": {
        "startTime": 1566.754,
        "endTime": 1575.791,
        "transcript": "Asvaircarilartut-gguq anagulluki-llu yagiraluki wall'u qatpagalluki. Tua-i-gguq caceturcarluki.",
        "translation": "They said that we make them unstable by physically or verbally abusing them. They say that we make them impertinent."
    },
    "170": {
        "startTime": 1577.69,
        "endTime": 1580.915,
        "transcript": "Caceturcalarait-gguq tuaten.",
        "translation": "They say that they make them impertinent like that."
    },
    "171": {
        "startTime": 1581.513,
        "endTime": 1592.213,
        "transcript": "Mikelnguut makut eyurnakenrilngurtun ellirluki pinarqelliniut.",
        "translation": "It turns out that we must raise children to make them feel like we do not defend them."
    },
    "172": {
        "startTime": 1595.396,
        "endTime": 1603.321,
        "transcript": "Eyuratukait-gguq qannguarulluki-llu angayuqateng nep'ngevkatuit.",
        "translation": "They say that those who are defended and spoken to without thought make discord among their parents."
    },
    "173": {
        "startTime": 1631.5,
        "endTime": 1643.9,
        "transcript": "Maqilriit taq'aqata kan'a maqillerteng tayima qam'aqan iliit egalilartuq, egalra qasgim patuluku.",
        "translation": "When they were done taking sweat baths and the fire down there had gone out, one of them would place the cover on the smoke hole of the community house."
    },
    "174": {
        "startTime": 1644.48,
        "endTime": 1655.967,
        "transcript": "Nutaan-llu paturraarluku tua-i imkut angutet matarrarmeng waten itraqamta uitauralartut akluksaunateng. Tua-i kinercira'arluteng pilallilriit.",
        "translation": "And then after they close it, the men would sit naked like this without having put on clothes when we come in. They were probably drying off."
    },
    "175": {
        "startTime": 1658.103,
        "endTime": 1663.878,
        "transcript": "Ukut tua-i Aagurmiut Urucararmiut-llu ataucimek qasgingqertut.",
        "translation": "The people of Aagurmiut and Urucararmiut had one community house."
    },
    "176": {
        "startTime": 1665.429,
        "endTime": 1672.292,
        "transcript": "Iliini waten uksumi ukut Aagurmiut maqiyunglliniaqameng",
        "translation": "Sometimes in the winter like this, when the people of Aagurmiut wanted to take sweat baths"
    },
    "177": {
        "startTime": 1672.953,
        "endTime": 1683.977,
        "transcript": "Qamuutara'arluteng muragmek uciluteng ikamrarluteng malikurluteng qasgimun aglartut unaggun Kepenkuullrani un'a Kepenkugkun.",
        "translation": "They would go to the community house together with sleds filled with wood though Kepenkuk down there when it used to be called Kepenkuk."
    },
    "178": {
        "startTime": 1684.777,
        "endTime": 1692.727,
        "transcript": "Tua-i yaavet qasgimun agluteng ataucimek qasgingqerrameng ukut Urucararmiut kiaqliit-ll' ukut Aagurmiunek pitullrit.",
        "translation": "They would go to the community house over there because Urucararmiut and what was Aagurmiut had one community house."
    },
    "179": {
        "startTime": 1692.746,
        "endTime": 1695.796,
        "transcript": "Aagurmiunguyaaqut kankut waniwa.",
        "translation": "It's actually called Aagurmiut down there."
    },
    "180": {
        "startTime": 1720.068,
        "endTime": 1729.793,
        "transcript": "Wiinga wani qaqimalua ayagnillruunga-wa aipangqerrsaramun.",
        "translation": "I started off completely prepared to be married."
    },
    "181": {
        "startTime": 1729.81,
        "endTime": 1739.36,
        "transcript": "Tau͡gaam maurluirutma-wa, mom-ama-llu, aatama-llu qanrut'lallruanga",
        "translation": "But my late grandmother, and my mom, and my father would tell me"
    },
    "182": {
        "startTime": 1739.743,
        "endTime": 1743.456,
        "transcript": "Aipamnun-wa tua-i mulngaklua pillerkamnek.",
        "translation": "That I should be careful with my spouse."
    },
    "183": {
        "startTime": 1743.924,
        "endTime": 1754.949,
        "transcript": "Cali-llu yuut assiinaku qanrutkengraatgu qanrut'laasqevkenaku.",
        "translation": "Also, even if people say bad things about him, they told me not to tell him"
    },
    "184": {
        "startTime": 1756.109,
        "endTime": 1765.243,
        "transcript": "Cali-llu cali aipangqellrianga, kinguqlingqellrianga-w' angutmek.",
        "translation": "Also, I have a companion, a male younger sibling."
    },
    "185": {
        "startTime": 1765.424,
        "endTime": 1777.036,
        "transcript": "Cali qanrut'lallruat nulirra wani piciatun qanrutkengraatgu ukvekesqevkenaki iingakun tangenrrilkaku.",
        "translation": "They also used to tell him that even if people say various things about his wife not to believe them if he hasn't seen it with his own eyes."
    },
    "186": {
        "startTime": 1777.198,
        "endTime": 1780.498,
        "transcript": "Tuaten-llu wiinga aatama qanrut'lallruanga.",
        "translation": "My father also used to tell me that."
    },
    "187": {
        "startTime": 1780.61,
        "endTime": 1790.8,
        "transcript": "Piciatun tua-i-wa aipaqa kamakelaasqevkenaku wiinga piksailkuma.",
        "translation": "He said that I should not suspect my spouse of various things if I haven't done them."
    },
    "188": {
        "startTime": 1791.427,
        "endTime": 1794.79,
        "transcript": "Arnanun-llu allanun ellilalaasqevkenaku.",
        "translation": "I also shouldn't accuse him of being with other women."
    },
    "189": {
        "startTime": 1794.873,
        "endTime": 1800.985,
        "transcript": "Tamana-wa pim, nepngurutnguniluku.",
        "translation": "He said that, you know, that brings discord."
    },
    "190": {
        "startTime": 1801.006,
        "endTime": 1809.656,
        "transcript": "Cali-llu uika-wa anagulluku ilangciaralaasqevkenaku qanrucimalallrulua.",
        "translation": "I was also told not to excessively tease my husband."
    },
    "191": {
        "startTime": 1809.675,
        "endTime": 1813.713,
        "transcript": "Tuamtell' cali waten qanrutaqlua:",
        "translation": "And then they would also tell me this:"
    },
    "192": {
        "startTime": 1813.798,
        "endTime": 1820.911,
        "transcript": "Caileng'e'rma canek-llu nuqlit'ngerma waten qanlaasqevkenii piiturlua.",
        "translation": "Even if I have nothing or am short on things not to say that I have nothing."
    },
    "193": {
        "startTime": 1821.15,
        "endTime": 1828.475,
        "transcript": "Atam-gguq umyugaa pekcet'larniarqa taum aiparma.",
        "translation": "They said that I would make my spouse's mind be in turmoil."
    },
    "194": {
        "startTime": 1828.632,
        "endTime": 1831.395,
        "transcript": "Waten qanrucimalallruunga.",
        "translation": "This is what I was told."
    },
    "195": {
        "startTime": 1831.449,
        "endTime": 1840.286,
        "transcript": "Cali-llu kamakuurullunuk pilaasqevkenanuk inerquumalallruukuk.",
        "translation": "We were also admonished against always being suspicious of each other."
    },
    "196": {
        "startTime": 1840.88,
        "endTime": 1844.967,
        "transcript": "Tau͡gaam-gguq pitulit aipateng kamaketuit.",
        "translation": "They said that those who are guilty are the ones who suspect their spouses."
    },
    "197": {
        "startTime": 1869.149,
        "endTime": 1884.999,
        "transcript": "Murilkellemni tua-i ava-i qanrutamken qasgiq pingna kana-i ug'um Joe Lomack-am Building-aam nuniini wani kellirneraani uitallruuq.",
        "translation": "I just told you about what I observed, that the community house inland was down toward the water from the Joe Lomack Building."
    },
    "198": {
        "startTime": 1886.243,
        "endTime": 1893.556,
        "transcript": "Urucaramek pitullrat nanvauvkenani tua-i kinerrluni, tau͡gaam kuigluni.",
        "translation": "The place they called Urucaraq wasn't a lake, was dry, but had a river."
    },
    "199": {
        "startTime": 1894.443,
        "endTime": 1897.893,
        "transcript": "Kuiga-ll' tauna tua-i bridge-arluni unaggun.",
        "translation": "And the river had a bridge down there."
    },
    "200": {
        "startTime": 1898.087,
        "endTime": 1906.812,
        "transcript": "Ama-i elitnaurvilleq ciuqliq qamani, qamani Moravian-aat agayuviim-wa yaatiini, agayuvillrem.",
        "translation": "And the first school upriver, upriver over from the Moravian church, the old church."
    },
    "201": {
        "startTime": 1907.218,
        "endTime": 1915.918,
        "transcript": "Tuss'arartangqellruuq tua-i tuskanek kanavet Aagurmiunun tekilluni, wagg'uq uumun Luqinqumun.",
        "translation": "There were boardwalks made of plywood all the way to Aagurmiut down there to where they called Luqinquq."
    },
    "202": {
        "startTime": 1916.637,
        "endTime": 1919.012,
        "transcript": "Luqinquq kipusvigluni tuani.",
        "translation": "Luqinquq had a store there."
    },
    "203": {
        "startTime": 1920.293,
        "endTime": 1928.331,
        "transcript": "Aiparluni au͡g'umek Kass'amek ketiini eneluni. Paatnaqlinikiit-wa tamatum nalliini. Wagg'uq una Kassaussaaq.",
        "translation": "He had a Caucasian companion with a house toward the water from him. He was probably his partner at the time. They called him Kassaussaaq."
    },
    "204": {
        "startTime": 1929.469,
        "endTime": 1935.106,
        "transcript": "Au͡gkut yull'urluut tua-i aciqayuameng piciatun ayuqaitnek.",
        "translation": "It was because those people back then would give them whatever names suited them."
    },
    "205": {
        "startTime": 1938.344,
        "endTime": 1953.706,
        "transcript": "Tamaa-i tua-i ellangellruunga ukut tua-i Kass'at maani akuliitni, makut Aagurmiut Urucaram-ll' akuliitni amllerpek'nateng tua-i.",
        "translation": "I grew up at the time without a lot of Caucasians here between Aagurmiut and Urucuaraq."
    },
    "206": {
        "startTime": 1953.907,
        "endTime": 1956.869,
        "transcript": "Kenirkauya'rmek-llu qanlalriit ava-i.",
        "translation": "They also talked about Kenirkauyar over there."
    },
    "207": {
        "startTime": 1956.945,
        "endTime": 1962.432,
        "transcript": "Tuana-ll' Kenirkauyar maani agnguarviulallruuq.",
        "translation": "And Kenirkauyar was a Western dancing hall here."
    },
    "208": {
        "startTime": 1962.445,
        "endTime": 1967.632,
        "transcript": "Tau͡gaam tam' piciatun pivkenateng, waten Maqinermi tau͡gaam.",
        "translation": "But it wasn't at any time, only on Saturdays."
    },
    "209": {
        "startTime": 1968.745,
        "endTime": 1973.257,
        "transcript": "Cali-llu 12 kela'agmun tekilluku.",
        "translation": "They also went until 12 o'clock."
    },
    "210": {
        "startTime": 1973.845,
        "endTime": 1979.27,
        "transcript": "Taum tua-i taqevkalarai, kesianek-llu aquivkarpek'naki.",
        "translation": "That was when they stopped, and they didn't let them do it all the time."
    },
    "211": {
        "startTime": 1980.001,
        "endTime": 1985.826,
        "transcript": "Unuk quka'arqan utercet'laraitkut nunamteńun, inerqualuta-llu tarritesqevkenata.",
        "translation": "They would have us go back to our villages at midnight and admonish us against wandering about."
    },
    "212": {
        "startTime": 1986.445,
        "endTime": 1997.945,
        "transcript": "Tang au͡gkut makut Kass'at-llu au͡gkut ciuqliit makutun Yugtun ikayuasnganateng atunem ayuqellrulliniliriit tamaani.",
        "translation": "You see, the first Caucasians back then also seemed to help each other like Yupiit."
    },
    "213": {
        "startTime": 1998.727,
        "endTime": 2007.989,
        "transcript": "Wangkuta-llu Yuungramta tua-i-wa iliini Kassaunge'rmeng inerquqa'aqluta pitullruut.",
        "translation": "Even if we were Yup'ik, even the Caucasians would admonish us."
    },
    "214": {
        "startTime": 2029.69,
        "endTime": 2037.552,
        "transcript": "Eyuratukait-gguq qannguarulluki-llu angayuqateng nep'ngevkatuit.",
        "translation": "They say that those who are defended and spoken to without respect bring discord to their parents."
    },
    "215": {
        "startTime": 2038.44,
        "endTime": 2046.678,
        "transcript": "Cali wiinga tamaa-i tuaten qanrucimalallrulua, mom-amnek-llu qanrucimalallrulua.",
        "translation": "That's what I used to be told, and that's what my mother told me."
    },
    "216": {
        "startTime": 2050.578,
        "endTime": 2061.891,
        "transcript": "Pingraatnga-llu iliini taqsuqa'arrlua-llu piyaaqaqama inerqulallruanga qanrutkelaasqevkenaki tamakut.",
        "translation": "And no matter what, when I sometimes was fed up, she would admonish me not to talk about those."
    },
    "217": {
        "startTime": 2062.628,
        "endTime": 2067.153,
        "transcript": "Atam-gguq ayagneqlua-llu yuut nepengniartut.",
        "translation": "She said that I would be the cause of discord among people."
    },
    "218": {
        "startTime": 2067.497,
        "endTime": 2081.597,
        "transcript": "Tuamtell' cali pingraata qialua-llu utertelaasqevkenii inerquraqlua.",
        "translation": "And then she said that no matter what they do, she admonished me against coming home crying."
    },
    "219": {
        "startTime": 2083.816,
        "endTime": 2089.091,
        "transcript": "Tua-i-llu wiinga-llu atunrilengramki wani",
        "translation": "And then even if I never did that"
    },
    "220": {
        "startTime": 2089.41,
        "endTime": 2103.022,
        "transcript": "Irnianka miklermeggni qialuteng itraqata tua-i aatama-llu wiinga tuaten qanrut'lallruanga pinaqngama pinilua.",
        "translation": "When my children would come in crying when they were small, my father would tell me that because he said I needed it."
    },
    "221": {
        "startTime": 2103.735,
        "endTime": 2109.485,
        "transcript": "Tua-i-ll' wiinga anagyaaqevkenii-llu pillruyuklua uitaaqlua.",
        "translation": "And then I would not run away, but stay because I thought that I did."
    },
    "222": {
        "startTime": 2109.969,
        "endTime": 2129.258,
        "transcript": "Tua-i-llu waten mikelnguut ciunermeggnun tamakut inerquumaaqameng anagyaaqevkenateng-llu taqtulliniut tua-i taqesqellriani.",
        "translation": "And then when children are admonished like this for the benefit of their futures, it turns out they do not run away but stop when they are told to."
    },
    "223": {
        "startTime": 2129.409,
        "endTime": 2134.042,
        "transcript": "Waten-llu pivkenaki: \"Piciqaqa tauna.\"",
        "translation": "And do not say this to them: \"I will take care of him.\""
    },
    "224": {
        "startTime": 2134.144,
        "endTime": 2141.088,
        "transcript": "Tuaten piyukait utqerteturituut-llu-gguq qialuteng enemeggnun elilluteng.",
        "translation": "Children who are treated like that learn to go home crying."
    },
    "225": {
        "startTime": 2141.2,
        "endTime": 2147.789,
        "transcript": "Tua-i-ll' eyurnakuuryukait",
        "translation": "And then the ones that they keep defending"
    },
    "226": {
        "startTime": 2147.824,
        "endTime": 2158.179,
        "transcript": "Taumek wani inerquutngullinilria iqluyaramun qannguaryaramun-llu agarutnguniluku tamana.",
        "translation": "That's why it's admonished against, because it leads to lying and saying things without consideration."
    },
    "227": {
        "startTime": 2182.581,
        "endTime": 2191.259,
        "transcript": "Makut-llu tangllerrlugnarqellriit-wa tua-i makut pisciigalnguut-llu ikayuasqelluki pitullruitkut.",
        "translation": "They also told us to help those who looked destitute and who were unable."
    },
    "228": {
        "startTime": 2191.67,
        "endTime": 2198.615,
        "transcript": "Cali-llu tangnerrlugnarqengraan yuk temciarautekesqenritaat agurrluku.",
        "translation": "They also told us never to make fun of anyone even if they look funny."
    },
    "229": {
        "startTime": 2199.015,
        "endTime": 2200.648,
        "transcript": "Assiicugnarquq tamana.",
        "translation": "That is probably bad."
    },
    "230": {
        "startTime": 2203.971,
        "endTime": 2210.56,
        "transcript": "Tau͡gaam ikayuangnaqluki makut ak'allaraat pisciigalnguut pisqetullruit.",
        "translation": "Instead, they told us to help the older ones who were unable."
    },
    "231": {
        "startTime": 2212.97,
        "endTime": 2215.103,
        "transcript": "Yuum-gguq umyugaa tukniuq.",
        "translation": "They say a person's mind is powerful."
    },
    "232": {
        "startTime": 2217.742,
        "endTime": 2230.864,
        "transcript": "Cali-llu enemun allamun itengramta agu kenrraungraan ussukcarraungraan-llu ataucirraungraan tamaaken enemek teguqautesqevkenii qanrutetullruanga au͡g'um qanrutesteḿa.",
        "translation": "Also, even if we enter another house, my teacher would tell me to never take even a single match or nail from that house."
    },
    "233": {
        "startTime": 2232.538,
        "endTime": 2234.06,
        "transcript": "Qaillun pitaa?",
        "translation": "How much more time?"
    },
    "234": {
        "startTime": 2235.839,
        "endTime": 2245.017,
        "transcript": "Cali-llu-gguq yuilqumun, yuilqumi tua-i yuum-gguq ellillni nalluyagucuitaa yuilqurrungraan.",
        "translation": "He also said that even in the wilderness, a person doesn't forget what he put, even in the wilderness."
    },
    "235": {
        "startTime": 2245.948,
        "endTime": 2248.104,
        "transcript": "Ilumun tamana piciuyugnarquq.",
        "translation": "That must be true."
    },
    "236": {
        "startTime": 2251.013,
        "endTime": 2254.813,
        "transcript": "Yuilqurrungraan yuum ellillni nalluyagucuitniluku.",
        "translation": "He said that a person doesn't forget what he put even in the wilderness."
    },
    "237": {
        "startTime": 2279.041,
        "endTime": 2283.03,
        "transcript": "Kiagmi-llu waten avani marami uitaaqamta",
        "translation": "And when we were in the marshes over there in the summer like this"
    },
    "238": {
        "startTime": 2283.065,
        "endTime": 2287.987,
        "transcript": "Tua-i-w' it'gairnairutaqan kamilamta pek'ngaqamta",
        "translation": "When our feet wouldn't get cold and we started walking around barefoot"
    },
    "239": {
        "startTime": 2287.989,
        "endTime": 2298.366,
        "transcript": "Curumteńun makucinun it'gaput unugmi ungirvangaqata it'gaput anurrulluki aunrarqengaqluteng.",
        "translation": "When our feet were itchy at night, we would take out our feet to our bedding and they would start bleeding."
    },
    "240": {
        "startTime": 2298.371,
        "endTime": 2302.271,
        "transcript": "Avalitkevkenaki-llu ellimeqakut ayagluta.",
        "translation": "And we didn't use them as an excuse when they told us to travel."
    },
    "241": {
        "startTime": 2302.418,
        "endTime": 2307.285,
        "transcript": "Mermun tus'utaqamceteng iliini qacervatulriit.",
        "translation": "When we stepped into water, they would sometimes sting."
    },
    "242": {
        "startTime": 2308.464,
        "endTime": 2316.957,
        "transcript": "Waterrlainaq, waterrlainaq kesiin kangarluta maaggun callarqelluteng, akunlait-llu callarqelluteng.",
        "translation": "This was the only way we walked, and they became raw, and they became raw between the toes."
    },
    "243": {
        "startTime": 2317.182,
        "endTime": 2326.115,
        "transcript": "Cakneq tua-i maavet yuilqumun ayagaqamta aunraurassiyaalria camek qecukaulluta nemraqluku.",
        "translation": "When we went to the wilderness, we would pull something out and bandage the part that was bleeding too much."
    },
    "244": {
        "startTime": 2327.541,
        "endTime": 2332.118,
        "transcript": "Camek-ll' avaliciyuunata nepaunata yuuluta.",
        "translation": "And we lived without making any excuses but were quiet."
    },
    "245": {
        "startTime": 2334.712,
        "endTime": 2338.934,
        "transcript": "Enem iluani nepliryugnaunaqluta yuugaqluta.",
        "translation": "We lived without any discord in the house."
    },
    "246": {
        "startTime": 2339.908,
        "endTime": 2349.641,
        "transcript": "Nepliryarpiaqumta-llu uyuraput-llu anglaniluta piyarpiaqumta inerqurrluta usviircaasqevkenata.",
        "translation": "And then when we and our younger siblings almost made too much noise having fun, they would admonish us against acting foolish."
    },
    "247": {
        "startTime": 2365.785,
        "endTime": 2370.118,
        "transcript": "Cetamainguluteng-ll' imkut family-nek imkut pitukait Kass'at.",
        "translation": "There were four in what is called a family in English."
    },
    "248": {
        "startTime": 2370.804,
        "endTime": 2378.748,
        "transcript": "Tauna atauciq yugyagluteng enekluku tamaa-i piarkaq ilakutellriit imkut.",
        "translation": "That big family had that house as they were supposed to."
    },
    "249": {
        "startTime": 2378.905,
        "endTime": 2383.327,
        "transcript": "Cali-llu tamakut waten tamaani enemi uitallermeggni",
        "translation": "Also, when they stayed in that house like this"
    },
    "250": {
        "startTime": 2383.645,
        "endTime": 2398.701,
        "transcript": "Makut neqkaaraat neqkat, taukut family-t kiimeng pivkenaki ukut enemiut tamarmeng tua-i neqekluki piaqluki tamakut neqkateng, neqkaukarateng.",
        "translation": "These food to eat, those familes weren't the only ones to have them, but everyone in the house would eat from what food they had."
    },
    "251": {
        "startTime": 2399.819,
        "endTime": 2410.774,
        "transcript": "Ilait tua-i enengqetuyaaqut, yuungnaquralriit-llu ataucimek kiimeng enem iluani uitaluteng enekaqluku.",
        "translation": "Some of them have houses, and the ones trying to survive would stay in one house that they own."
    },
    "252": {
        "startTime": 2410.856,
        "endTime": 2416.367,
        "transcript": "Tua-i tau͡gaam tuaten yugyagglainatullrulriit.",
        "translation": "But they always had a lot of people."
    },
    "253": {
        "startTime": 2417.618,
        "endTime": 2423.695,
        "transcript": "Ukut ilakelriit qavciunguluteng enem iluani uitatullruut, ilakelriit tau͡gaam.",
        "translation": "These familes with several members would live in a house, only those families."
    },
    "254": {
        "startTime": 2424.329,
        "endTime": 2427.129,
        "transcript": "Tuaten tua-i ayuquciqellruat tamana.",
        "translation": "That's what they were like."
    },
    "255": {
        "startTime": 2427.137,
        "endTime": 2438.715,
        "transcript": "Cali tamana neqkarteng yuilqumek unangkengateng can'giiret, iqalluat, wall' piciatun tua-i neqet uksumi, uksuarmi pitaqetukiit kumlanret",
        "translation": "And their food that they get from the wilderness, blackfish, saffron cods, or whatever food they get in the winter and fall for frozen raw fish"
    },
    "256": {
        "startTime": 2438.974,
        "endTime": 2453.163,
        "transcript": "Enem iluani tua-i taukut-llu pitaqestaita kiimeng pivkenaki, enem tau͡gaam iluanelnguut tamarmeng, amani-llu qasgimi anguteteng ilakluki tua-i neqautekaqluki tauna neqa.",
        "translation": "The yweren't food for only the ones in the house or the ones who caught them, but for everyone in the house along with the men in the community house."
    },
    "257": {
        "startTime": 2480.066,
        "endTime": 2489.166,
        "transcript": "Mat'um maa-i nalliini avani ciuliat yuucillrat cimiami mat'um nalliini",
        "translation": "These days, because the old life of the people long ago has changed"
    },
    "258": {
        "startTime": 2489.332,
        "endTime": 2497.477,
        "transcript": "Tua-i imutun nutaramek wangkuta Yup'igni yuuciqenrilkemteńek yuucingelriatun ayuqliriamta",
        "translation": "Since it's like we Yupiit have started living a new life unlike our traditional life"
    },
    "259": {
        "startTime": 2497.588,
        "endTime": 2505.654,
        "transcript": "Makut ayagyuamta nutem yuucirput tua-i-w' nalluqapigtessiyaakataatgu",
        "translation": "Because our young people are going to completely forget our original lifestyle"
    },
    "260": {
        "startTime": 2505.665,
        "endTime": 2519.604,
        "transcript": "Makunek maa-i ak'a wangkuta ellangartellemta nallini eneketullemteńek maa-i maniilluki makunek taqutellriit ukut tua-i calilriit",
        "translation": "We show them the kinds of houses that we used to have when we were growing up that the workers have finished"
    },
    "261": {
        "startTime": 2519.637,
        "endTime": 2526.503,
        "transcript": "Man'a maani Yup'igput tua-i nutem yuucirput tamayunaitqapiaryaaqngan.",
        "translation": "Because we absolutely should not lose the original lifestyle of our Yup'ik people."
    },
    "262": {
        "startTime": 2526.632,
        "endTime": 2535.61,
        "transcript": "Cali-llu makunun ayagyuanun nalluvkayunaitqapiaryaaqngan Yupiuluta wangkuta nutem ayuquciqngamteggu.",
        "translation": "Also, we absolutely should not leave our young people in ignorance, because it is our ancient way as Yupiit."
    },
    "263": {
        "startTime": 2535.76,
        "endTime": 2538.449,
        "transcript": "Qivrunaqngan cakneq.",
        "translation": "Because it is so sad."
    },
    "264": {
        "startTime": 2538.469,
        "endTime": 2545.924,
        "transcript": "Maa-i tua-i utermun ayagyuamteńun tangerrluku elitesqumayaaqluku.",
        "translation": "Now, we look at our young people and want them to return and learn it."
    },
    "265": {
        "startTime": 2545.936,
        "endTime": 2554.591,
        "transcript": "Imutun-llu qanqainakun apertungramteggu tangerqaqsailatgu asgurakelriatun ayuqelaatgu",
        "translation": "And even though we only instruct them with words, because they seem to doubt it because they've never seen it"
    },
    "266": {
        "startTime": 2554.635,
        "endTime": 2561.258,
        "transcript": "Iingitgun maa-i nutaan piciuluku tangertelluki makunek ak'a eneketullritnek",
        "translation": "Let them see these houses they used to have long ago as true"
    },
    "267": {
        "startTime": 2561.275,
        "endTime": 2568.808,
        "transcript": "Wangkuta-llu angullemteńek makut Kass'at cait paivngarivailgata.",
        "translation": "And the thigns we were born in time to see before Western things became available."
    },
    "268": {
        "startTime": 2568.815,
        "endTime": 2579.004,
        "transcript": "Waten waniwa maa-i maniilluki eliyutkesqumaluki ayagyuamteńun makut caliaqekait maa-i.",
        "translation": "Now, they are working to show our young people so that they can learn from them."
    },
    "269": {
        "startTime": 2595.113,
        "endTime": 2603.457,
        "transcript": "Waten-wa tua-i makut uksillerkameggnun ayagluteng",
        "translation": "When thye went to their winter camps like this"
    },
    "270": {
        "startTime": 2603.502,
        "endTime": 2615.002,
        "transcript": "Taq'aqamegteki cali tua-i muraganek qupurrluteng taluyarkiurluteng unarcianek.",
        "translation": "When they were finished, they would split wood to make fish traps out of stright-graned pieces of wood."
    },
    "271": {
        "startTime": 2615.613,
        "endTime": 2622.146,
        "transcript": "Tamaa-i cali tamakut pilallruit.",
        "translation": "That's what they also used to do."
    },
    "272": {
        "startTime": 2622.536,
        "endTime": 2635.977,
        "transcript": "Makut maa-i ayagyuatemta, ayagyuarunrilnge'rmeng-wa callerkarteng, nemiallerkarteng, taluyillerkarteng-llu nallussiyaagluku",
        "translation": "Since these young people of ours, even if they're not young, are too ignorant about what to do, lashing fish traps, and making fish traps"
    },
    "273": {
        "startTime": 2636.126,
        "endTime": 2645.926,
        "transcript": "Yuullrat tamaa-i tamana tuaten ayuqesqumanriryaaqluki maa-i.",
        "translation": "We don't want their lives to be like that anymore now."
    },
    "274": {
        "startTime": 2647.485,
        "endTime": 2657.807,
        "transcript": "Nemiarluki neqsuutekanek, can'giirrsuutekanek, manignarrsuutekanek.",
        "translation": "Lashing fishing tools for blackfish and loche."
    },
    "275": {
        "startTime": 2659.165,
        "endTime": 2672.982,
        "transcript": "Makut tua-i neqet piit, angtaciit cuqluki, cukilegcuutet-llu nemiatullruit pissuutekiurluteng.",
        "translation": "They measure, you know, the size of the fish, and lash traps for sticklebacks."
    },
    "276": {
        "startTime": 2673.875,
        "endTime": 2681.12,
        "transcript": "Cali arnait missuullernek pivkenateng naparcilliluteng.",
        "translation": "Their women would also make grass baskets to hold fish, but not out of empty sacks."
    },
    "277": {
        "startTime": 2681.159,
        "endTime": 2689.615,
        "transcript": "Qayikvayagnek quyurrluteng naparcilliluteng assigtaillitarcecuunaki angutet.",
        "translation": "They would gather wheat grass to make baskets to hold caught fish so them wouldn't be without containers."
    },
    "278": {
        "startTime": 2690.014,
        "endTime": 2700.048,
        "transcript": "Tuaten tua-i ayuqetullrulriit tamakut angullrenka au͡gkut.",
        "translation": "That is what the people I was born in time to see were like."
    },
    "279": {
        "startTime": 2714.567,
        "endTime": 2719.611,
        "transcript": "Qanikcaq tangerrluku yullret imkut pitullrut.",
        "translation": "The people back then would gauge it by the snow."
    },
    "280": {
        "startTime": 2719.688,
        "endTime": 2730.285,
        "transcript": "Qanikci'rqan cali-llu tua-i-w' cikuli'rqan cikurrlugluni qanikcaumakuni",
        "translation": "When there's a lot of snow, and also when there's a lot of ice where the snow is partially frozen"
    },
    "281": {
        "startTime": 2730.468,
        "endTime": 2735.19,
        "transcript": "Cikuluku piaqan, nenglaiteqtaarluni-w' tua-i.",
        "translation": "When it freezes as it periodically warms up."
    },
    "282": {
        "startTime": 2735.259,
        "endTime": 2743.059,
        "transcript": "Tamana-gguq tua-i qanikci'rqan, qau͡gna-llu kiatvut qanikci'rqan mel'ituuq. Mel'irnilallruat.",
        "translation": "They say that when there's a lot of snow also upriver from us, there's a lot of water. They would say there's a lot of water."
    },
    "283": {
        "startTime": 2743.376,
        "endTime": 2750.143,
        "transcript": "Qanikcinqurraa-qaa elpet tangvallruan qanikcingkacagallrani?",
        "translation": "Did you see the snowiest time when there was a lot of snow?"
    },
    "284": {
        "startTime": 2750.154,
        "endTime": 2755.143,
        "transcript": "Qanikcitullruuq imumi mikluta maani. Qanikcipiatullruuq.",
        "translation": "There used to be a lot of snow here back when we were small. There was a lot of snow."
    },
    "285": {
        "startTime": 2755.322,
        "endTime": 2759.322,
        "transcript": "Enet-llu kankut mission house-at kiimeng qertullrulriit.",
        "translation": "And the houses down there, the mission house was the only elevated one."
    },
    "286": {
        "startTime": 2759.719,
        "endTime": 2764.33,
        "transcript": "Roof-ai tekilluki piaqluni atrarluni.",
        "translation": "It would reach their roof and slope down."
    },
    "287": {
        "startTime": 2764.487,
        "endTime": 2767.699,
        "transcript": "Mayurluta pagaavet ellu'urtaaraqluta.",
        "translation": "We would go up there and slide."
    },
    "288": {
        "startTime": 2767.816,
        "endTime": 2774.038,
        "transcript": "Elaturrat-llu amiigit qanikciurluki waten piaqluki igteńguluteng.",
        "translation": "And they would shovel tunnels to the doors of the porches like this."
    },
    "289": {
        "startTime": 2790.783,
        "endTime": 2795.028,
        "transcript": "Qanikcarpallrani-qaa Kuigpagmi murilkellruuten wall' nani?",
        "translation": "Did you observe a lot of snow on the Yukon or anywhere?"
    },
    "290": {
        "startTime": 2795.046,
        "endTime": 2800.513,
        "transcript": "Yaa, tamaani 1930's qanikcarpatullruuq tan'gurraulua.",
        "translation": "Yes, there used to be a lot of snow in the 1930's when I was a boy."
    },
    "291": {
        "startTime": 2800.963,
        "endTime": 2811.452,
        "transcript": "Iliikun ungaliquluni waten qaniquluni-ll' piaqan maraq cirmiggnilaraat, cikuluni-gguq.",
        "translation": "Sometimes, when it keeps snowing with repeated southern winds, they say that the marsh freezes, cirmiggluni as they say."
    },
    "292": {
        "startTime": 2811.967,
        "endTime": 2819.334,
        "transcript": "Maa-i qanikangqeng'e'rmi cirmigcimanrituq man'a nunapik.",
        "translation": "Now, even though there's snow, the tundra here is not frozen."
    },
    "293": {
        "startTime": 2821.587,
        "endTime": 2826.387,
        "transcript": "Waten qanikcing'e'rmi iliikun merpayuituq mel'ing'e'rmi.",
        "translation": "Even though there's a lot of snow like this, there's not a flood of water even though there's a lot."
    },
    "294": {
        "startTime": 2826.396,
        "endTime": 2830.796,
        "transcript": "Tau͡gaam cikuineq man'a enetnaciarlartuq.",
        "translation": "But the melted ice is slow to flow out."
    },
    "295": {
        "startTime": 2831.292,
        "endTime": 2837.803,
        "transcript": "Tamaa-i-gguq aipaagni qerruvkaqtaarluni merkani nangciqaa.",
        "translation": "They say that the water will be gone probably when it repeatedly freezes."
    },
    "296": {
        "startTime": 2839.023,
        "endTime": 2845.107,
        "transcript": "Tau͡gaam imumek cikuugaqami tuatnasciigataqan nutaan merpaglartuq.",
        "translation": "But when there's a lot of ice that can't do that, then there is a flood of water."
    },
    "297": {
        "startTime": 2845.117,
        "endTime": 2850.595,
        "transcript": "Cali makut kuiget qanikcarmek amllermek imangqerrluteng cali ciku mamtunrituq.",
        "translation": "Also, when these rivers have a lot of snow, the ice isn't thick."
    },
    "298": {
        "startTime": 2850.62,
        "endTime": 2860.198,
        "transcript": "Mamtulaucimitun mamtunrilan imartung'e'rmi ulerpagnayukluku wii umyuarteqenritua tamatumek picirluku.",
        "translation": "Because it's not as thick as it usually is, even if there's a lot of water, I don't think there'll be a flood for that reason."
    },
    "299": {
        "startTime": 2882.547,
        "endTime": 2888.769,
        "transcript": "Qaillun waten maa-i February-q nangyartulria, qaillun tamaani uptelallruat up'nerkiyallerkameggnun?",
        "translation": "With how February is ending now, how would they prepare to go to their spring camps?"
    },
    "300": {
        "startTime": 2888.787,
        "endTime": 2893.354,
        "transcript": "Up'nerkiyaqata'arqameng-wa April-aami uptenglallrulriit.",
        "translation": "When they were going to go to their spring camps, they would start preparing in April."
    },
    "301": {
        "startTime": 2893.4,
        "endTime": 2897.678,
        "transcript": "Qaniilarluteng-llu canek neqkameggnek up'nerkarpak",
        "translation": "And prepare food supplies for the entire spring"
    },
    "302": {
        "startTime": 2899.19,
        "endTime": 2903.29,
        "transcript": "Pelatekateng-llu civcarturluki, and...",
        "translation": "And setting up their tents, and..."
    },
    "303": {
        "startTime": 2903.738,
        "endTime": 2905.872,
        "transcript": "Atam-llu qitevcugniartua.",
        "translation": "See, I'll slip into English a lot."
    },
    "304": {
        "startTime": 2906.913,
        "endTime": 2913.813,
        "transcript": "Pinek-llu, angyateng-llu cali ayaulluki, aguuteteng-llu.",
        "translation": "And, you know, they would bring their boats and canoes."
    },
    "305": {
        "startTime": 2914.28,
        "endTime": 2918.325,
        "transcript": "Cat tua-i aturyugarkateng up'nerkillerni ayaulluki.",
        "translation": "They brought the things they would need in the spring camps."
    },
    "306": {
        "startTime": 2918.654,
        "endTime": 2927.009,
        "transcript": "Nutaan-llu April-aaq man'a qukallra kituan nutaan wangkuta upagluta.",
        "translation": "And then when the middle of April had passed, we would relocate."
    },
    "307": {
        "startTime": 2927.615,
        "endTime": 2934.26,
        "transcript": "Tua-i tekilluta nunakamteńun. Cakneq tua-i assirluni nunaniqluni.",
        "translation": "We would arrive to our settlement. It was nice and wonderful."
    },
    "308": {
        "startTime": 2957.821,
        "endTime": 2967.497,
        "transcript": "Man'a qanruyutvut: nunavut arcaqerluku meq-llu kencikesqumaluku pitullruitkut.",
        "translation": "This was the traditional wisdom passed to us: they told us to respect especially the land and water."
    },
    "309": {
        "startTime": 2969.695,
        "endTime": 2971.306,
        "transcript": "Kencikluku.",
        "translation": "Respect it."
    },
    "310": {
        "startTime": 2971.32,
        "endTime": 2983.098,
        "transcript": "Wagg'uq-am waniw' tua-i ayuqucirtuastemta ayuqucia: wangkuta-gguq qantamcetun pitarrluku.",
        "translation": "This is what our instruction was like: respect it as much as our bowls."
    },
    "311": {
        "startTime": 2983.37,
        "endTime": 2987.603,
        "transcript": "Mat'um nalliini tuaten ellinrituq. Allaurtuq.",
        "translation": "It's not like that these days. It's different."
    },
    "312": {
        "startTime": 2989.881,
        "endTime": 2992.97,
        "transcript": "Cauga tauna wani qantamcetun pitarrluku?",
        "translation": "What does it mean, \"as much as our bowls?\""
    },
    "313": {
        "startTime": 2993.201,
        "endTime": 2995.679,
        "transcript": "Waten tua-i taringela'arqa:",
        "translation": "This is how I understand it:"
    },
    "314": {
        "startTime": 2996.859,
        "endTime": 3006.57,
        "transcript": "Qantaput man'a wangkuta ner'aqamta, tamaani-w' ciuqvani qantangqetulliniami yuk atauciq qantani tua-i murilkelluku pillilria.",
        "translation": "Our bowls when we eat, at least back then, it's probably because a person long ago would have only one bowl and personally kept it."
    },
    "315": {
        "startTime": 3007.12,
        "endTime": 3010.053,
        "transcript": "Kenekluku tua-i, kencikluku.",
        "translation": "he treated it with love and respect."
    },
    "316": {
        "startTime": 3011.495,
        "endTime": 3021.706,
        "transcript": "Cuqyutekluku-am wiinga tamana pilaryukaqa nunavut meq-llu kencikesqelluku wangkuta qantamcetun pitarrluku.",
        "translation": "I think that that's a metaphor, to respect our land and water as much as our bowls."
    },
    "317": {
        "startTime": 3022.787,
        "endTime": 3026.965,
        "transcript": "Au͡gkut yullret tua-i man'a iliit qanruyutiit.",
        "translation": "This is part of the traditional wisdom of the people long ago."
    }
};